import React from 'react'

import { IconProps } from '../Types'

export const Link = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="Link"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="M8.18 10.48c.41.41.4 1.08 0 1.49-.46.45-1.9 1.89-3.26 3.24-1.08 1.07-1.08 2.82 0 3.89 1.07 1.06 2.78 1.06 3.83 0 .86-.86 1.95-1.95 3.29-3.29.41-.41 1.08-.41 1.49 0 .41.41.41 1.07 0 1.49-1.34 1.35-2.43 2.44-3.29 3.3-1.89 1.88-4.93 1.86-6.81 0-1.9-1.89-1.9-4.97 0-6.86 1.35-1.35 2.8-2.79 3.26-3.25.41-.41 1.08-.4 1.49 0ZM13.72 3.42c1.9-1.91 4.98-1.89 6.87 0 1.89 1.89 1.89 4.96-.01 6.85-.43.42-.85.85-1.28 1.27-.66.66-1.32 1.31-1.98 1.97-.41.41-1.08.41-1.49 0-.41-.41-.41-1.08 0-1.49.66-.66 1.32-1.31 1.98-1.97.42-.42.85-.84 1.27-1.26 1.07-1.07 1.08-2.8 0-3.88-1.08-1.08-2.81-1.08-3.88 0-.49.49-.98.99-1.48 1.49-.59.59-1.18 1.19-1.76 1.78-.41.41-1.08.41-1.49 0-.41-.41-.41-1.07 0-1.49.59-.59 1.17-1.18 1.76-1.77.49-.5.99-1 1.48-1.5Z"/><path fill-rule="evenodd" d="m15.8,8.21c.41.41.41,1.08,0,1.49l-6.1,6.08c-.41.41-1.08.41-1.49,0-.41-.41-.41-1.08,0-1.49l6.1-6.08c.41-.41,1.08-.41,1.49,0Z"/>',
    }}
  />
)

Link.displayName = 'Link'

export const tags = ['Link', '']
